module.exports = __webpack_public_path__ + "img/clipboard_white.d3506e9b.svg";